/**
 * Route configuration for HomeIQ application
 */

export const ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  
  // Auth
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  VERIFY_OTP: "/auth/verify-otp",
  
  // Assets
  ASSETS: "/assets",
  ASSET_DETAIL: "/assets/:id",
  WARRANTY_PLANS: "/warranty-plans",
  UPGRADE_OFFER: "/assets/:id/upgrade",
  UPGRADE_BROWSE_MODELS: "/assets/:id/upgrade/browse",
  UPGRADE_MODEL_DETAIL: "/assets/:id/upgrade/model/:modelId",
  UPGRADE_CHECKOUT: "/assets/:id/upgrade/checkout",
  UPGRADE_PROTECTION_PLANS: "/assets/:id/upgrade/plans",
  
  // Services
  SERVICES: "/services",
  SERVICE_BOOKING: "/services/:category/book",
  
  // Maintenance
  MAINTENANCE: "/maintenance",
  
  // Orders & Bookings
  ORDERS: "/orders",
  ORDER_DETAIL: "/orders/:orderId",
  BOOKINGS: "/bookings",
  BOOKING_DETAIL: "/bookings/:bookingId",

  // Claims
  CLAIMS: "/claims",
  
  // Settings
  SETTINGS: "/settings",
  PROFILE: "/profile",
  PAYMENT_METHODS: "/payment-methods",

  // Family
  FAMILY: "/family",
  INVITE_ACCEPT: "/invite/accept",

  // Onboarding
  ONBOARDING: "/onboarding",

  // Legal (public, no auth required)
  TERMS: "/terms",
  PRIVACY: "/privacy",
} as const;

/**
 * Helper function to generate asset detail route
 */
export function getAssetDetailRoute(assetId: string): string {
  return `/assets/${assetId}`;
}

/**
 * Helper function to generate order detail route
 */
export function getOrderDetailRoute(orderId: string): string {
  return `/orders/${orderId}`;
}

/**
 * Helper function to generate booking detail route
 */
export function getBookingDetailRoute(bookingId: string): string {
  return `/bookings/${bookingId}`;
}

/**
 * Helper function to generate service booking route
 */
export function getServiceBookingRoute(category: string): string {
  return `/services/${category}/book`;
}
